import React from 'react';
import ResponsiveECharts from './ResponsiveECharts';

// Repris tel quel de l'ancien Troisvagues.js (déjà en ECharts) : les 3
// niveaux de risque sont dessinés en aires pleines SANS stack (chacune part
// de 0), dans cet ordre précis — catastrophique dessinée en premier (donc
// en dessous des deux autres), courant en dernier (donc au-dessus). C'est ce
// qui donne l'effet de "vagues" superposées visible sur la maquette : chaque
// aire plus basse ne montre que la portion où elle dépasse les aires
// dessinées après elle.
const COULEUR_COURANT = '#FABE06';
const COULEUR_EXCEPTIONNEL = '#0027CC';
const COULEUR_CATASTROPHIQUE = '#DB04B9';

const donnees = (d) => (Array.isArray(d) ? d : []);

/**
 * Position de l'exploitation dans la distribution de risque des
 * exploitations comparables, aux 3 niveaux de risque (courant/exceptionnel/
 * catastrophique). Le marqueur en pointillés rouge (dataPerso) suit le
 * niveau choisi dans la sidebar.
 *
 * @param dataVagues7/20/50  [{x, y}] — population triée de la moins à la
 *   plus exposée (x = rang, y = % de produit brut)
 * @param dataQ1/Q2/Q3       repères verticaux de quartiles
 * @param dataPerso          position de l'exploitation (2 points, x constant)
 * @param maximum            borne haute de l'axe Y
 */
export default function Graph3Vagues({
  dataVagues7, dataVagues20, dataVagues50, dataQ1, dataQ2, dataQ3, dataPerso, maximum = 80,
}) {
  const makeArea = (nom, data, couleur) => ({
    name: nom,
    type: 'line',
    smooth: true,
    showSymbol: false,
    data: donnees(data).map((p) => [p.x, p.y]),
    lineStyle: { width: 0 },
    areaStyle: { color: couleur, opacity: 1 },
    itemStyle: { color: couleur },
    emphasis: { disabled: true },
  });

  const makeLigne = (nom, data, couleur, epaisseur, pointilles) => ({
    name: nom,
    type: 'line',
    smooth: false,
    showSymbol: false,
    data: donnees(data).map((p) => [p.x, p.y]),
    lineStyle: { color: couleur, width: epaisseur, type: pointilles ? 'dashed' : 'solid' },
    itemStyle: { color: couleur },
  });

  const option = {
    animation: false,
    tooltip: { show: false },
    grid: { left: 60, right: 20, top: 30, bottom: 48, containLabel: false },
    xAxis: {
      type: 'value',
      min: 1,
      max: 520,
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: { show: false },
      axisLabel: {
        show: true,
        color: '#000',
        fontSize: 12,
        margin: 8,
        formatter: (valeur) => {
          if (Math.abs(valeur - 130) < 5) return '25% les moins exposées';
          if (Math.abs(valeur - 260) < 5) return '50%';
          if (Math.abs(valeur - 390) < 5) return '25% les plus exposées';
          return '';
        },
      },
    },
    yAxis: {
      type: 'value',
      min: 0,
      max: maximum,
      name: '%PB',
      nameLocation: 'end',
      nameGap: 12,
      nameTextStyle: { fontSize: 13, fontWeight: 600, color: '#000', align: 'left' },
      splitNumber: 8,
      splitLine: { lineStyle: { color: '#e2e5ea' } },
      axisLabel: { fontSize: 12, color: '#000' },
    },
    series: [
      makeArea('Catastrophique', dataVagues50, COULEUR_CATASTROPHIQUE),
      makeArea('Exceptionnel', dataVagues20, COULEUR_EXCEPTIONNEL),
      makeArea('Courant', dataVagues7, COULEUR_COURANT),
      makeLigne('Q1', dataQ1, '#000000', 3, false),
      makeLigne('Q2', dataQ2, '#000000', 3, false),
      makeLigne('Q3', dataQ3, '#000000', 3, false),
      makeLigne('Votre exploitation', dataPerso, '#E8362B', 4, true),
    ],
  };

  return <ResponsiveECharts option={option} style={{ height: 480 }} />;
}
